import React from "react";
import { Link } from "react-router-dom";
import styles from "./Sidebar.module.css"; // Sidebar.cssをインポート
import classNames from "classnames";

const Sidebar = ({ isOpen, toggleSidebar }) => {
  return (
    <aside
      className={classNames(styles.sidebar, {
        [styles.open]: isOpen,
        [styles.closed]: !isOpen,
      })}
    >
      <ul>
        <li onClick={toggleSidebar}>
          <Link to="/" className={styles.sidebarLink}>
            <span>Home</span>
          </Link>
        </li>
        <li onClick={toggleSidebar}>
          <Link to="/products" className={styles.sidebarLink}>
            Products
          </Link>
        </li>
        <li onClick={toggleSidebar}>
          <Link to="/contact" className={styles.sidebarLink}>
            Contact
          </Link>
        </li>
      </ul>
    </aside>
  );
};

export default Sidebar;
